import React from 'react';
import { connect } from 'react-redux';
import withRouter from '../../withRouter';

/** Панель отображения отсутсвия настройки вида каталога. */
class EmptyPanel extends React.Component {
    
    render() {
      console.log(this);
      return (
        <div className="text-danger text-center">
          <h1>Установите в настройках необходимую <strong>панель отображения данных</strong>.</h1>
        </div>        
      );
    }
  }
  
function mapStateToProps(state, props) {
  const { vset } = state;
  const { graph, lang } = props;
  return {
    graph: (graph)?graph: vset.graph,
    lang: (lang)?lang: vset.lang,
  };
}

export default withRouter(connect(mapStateToProps)(EmptyPanel));
